import { TextInput } from "react-admin"


const ProductFilters = [
  <TextInput source='productName_Contains' label='resources.filter.productNameContains' alwaysOn resettable />,
]

export default ProductFilters